function publish(type, value) {
    const event = new CustomEvent(type, value);
    window.dispatchEvent(event);
}

function onBodyReady(callback) {
    if (document.body) {
        callback();
    } else {
        window.addEventListener('DOMContentLoaded', function () {
            callback();
        });
    }
}

module.exports = {
    onBodyReady,
    publish
};
